import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icourrier-form-error',
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss',
})
export class FormErrorComponent {
  public readonly errorMessage = input.required<string>();
}
